export default "__VITE_ASSET__DxH9Npgd__"